import { Toast } from "@sscs/ui";
import { apiErrorToast } from "Utils";
import { useResendRegisterUserEmailMutation } from "../../services/users.api";

const useResendRegisterMemberEmail = () => {
  const [resendEmail, { isLoading: isResending }] =
    useResendRegisterUserEmailMutation();

  const handleResend = async (email: string) => {
    try {
      await resendEmail({
        email,
      }).unwrap();
    } catch (error) {
      apiErrorToast(error, "Could not resend verification email!");
      return;
    }

    Toast.show({
      title: "Verification email resent!",
      type: "success",
    });
  };

  return {
    isResending,
    handleResend,
  };
};

export default useResendRegisterMemberEmail;
